import React from 'react';
import { Calendar, Clock } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { StartSessionForm } from './StartSessionForm';

export default function WalkinSessionPanel({
  date, setDate, sessions, loading, selectedSession, setSelectedSession,
  doctors, docName, user, onRefresh,
}) {
  const defaultDoctorId = (user?.role === 'doctor'
    && doctors.find((d) => d.email === user?.email)?.id) || null;

  return (
    <aside className="rounded-2xl border border-[#D5DEE8] bg-white p-4 shadow-sm" data-testid="walkin-session-panel">
      <div className="flex items-center gap-2 mb-3">
        <Calendar className="h-4 w-4 text-[#F15A22]" />
        <span className="text-sm font-semibold text-[#071B34]">Open session</span>
      </div>
      <Input type="date" value={date} onChange={(e) => setDate(e.target.value)}
        className="h-9 mb-3 text-sm" data-testid="rec-date" />
      <div className="space-y-2 max-h-[58vh] overflow-y-auto">
        {loading ? <p className="text-sm text-[#5A6B7C]">Loading…</p>
          : sessions.length === 0 ? (
            <div className="text-sm text-[#5A6B7C] space-y-3">
              <p>No sessions on this date. Start one to register walk-ins.</p>
              <StartSessionForm doctors={doctors} date={date} defaultDoctorId={defaultDoctorId} onCreated={onRefresh} />
            </div>
          )
          : sessions.map((s) => (
            <button key={s.id} type="button" onClick={() => setSelectedSession(s)}
              className={`w-full text-left p-3 border rounded-xl transition ${
                selectedSession?.id === s.id
                  ? 'border-[#F15A22] bg-[#FFF7F3] ring-1 ring-[#F15A22]/30'
                  : 'border-[#D5DEE8] hover:bg-[#F8FAFC]'
              }`}
              data-testid={`rec-session-${s.id}`}>
              <div className="font-semibold text-sm text-[#071B34]">{docName(s.doctor_id)}</div>
              <div className="text-[11px] text-[#5A6B7C] flex items-center gap-2 mt-0.5">
                <Clock className="h-3 w-3" /> {s.start_time}–{s.end_time}
                <span className="ml-auto bg-amber-50 text-amber-800 px-1.5 py-0.5 rounded text-[10px] border border-amber-200">
                  Tokens {s.queue_counter || 0}
                </span>
              </div>
              <div className="text-[10px] text-[#9AADBE] mt-1">
                Fee ₹{s.consultation_fee || 0} · {s.source || 'session'}
              </div>
            </button>
          ))}
      </div>
      {sessions.length > 0 && (
        <details className="mt-3 text-xs text-[#5A6B7C]" data-testid="rec-add-session-toggle">
          <summary className="cursor-pointer select-none hover:text-[#071B34]">+ Start another session</summary>
          <div className="mt-3">
            <StartSessionForm doctors={doctors} date={date} defaultDoctorId={defaultDoctorId} onCreated={onRefresh} />
          </div>
        </details>
      )}
    </aside>
  );
}
